export default class microsoftUser {

	accessToken = '';
	username = '';
	name = '';
	isSignedIn = false;

	constructor(accessToken='', username='', name='', isSignedIn=false) {
		this.accessToken = accessToken;
		this.username = username;
		this.name = name;
		this.isSignedIn = isSignedIn;
	}

}